import { motion } from "framer-motion";

const Card = ({ children, className = "" }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.25 }}
      className={`bg-white rounded-xl shadow-md border p-4 hover:shadow-lg transition dark:bg-slate-900/50 dark:border-slate-700 dark:shadow-none dark:hover:shadow-black/30 ${className}`}
    >
      {children}
    </motion.div>
  );
};

export default Card;
